import React from 'react';
import styled from '@emotion/styled';
import MuiBox from '@mui/material/Box';
import { type BoxProps as MuiBoxProps, spacing } from '@mui/system';

const StyledBox = styled(MuiBox)`
  ${spacing}
`;

export type BoxProps = MuiBoxProps & {
  className?: string;
};

const Box = ({ children, className, ...props }: BoxProps) => (
  <StyledBox {...props} className={className}>
    {children}
  </StyledBox>
);

export default Box;
